// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__f4xBL","carouselImgContainer":"styles_carouselImgContainer__QOGcK","fadeInOut":"styles_fadeInOut__adeul","loader":"styles_loader__RZH80"};